import { LoadType } from '@tencent/ark-extensions';

/**
 * 协作者面板
 */
export default {
    name: 'docs-component-guide-interflow',
    loadType: LoadType.EAGER,
};
